import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckoutForm from './CheckoutForm';

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mockupId, quantity, totalAmount, currency, shippingAddress } = location.state || {};

  if (!mockupId || !quantity || !totalAmount || !currency || !shippingAddress) {
    // Redirect to configure-mockup page with an error message if payment details are missing
    navigate('/configure-mockup', { state: { error: 'Payment details missing. Please go back and try again.' } });
    return null;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Complete Your Purchase</h2>
        <p className="text-center mb-6">Amount: {totalAmount} {currency.toUpperCase()}</p>
        <CheckoutForm
          mockupId={mockupId}
          quantity={quantity}
          totalAmount={totalAmount}
          currency={currency}
          shippingAddress={shippingAddress}
        />
      </div>
    </div>
  );
};

export default PaymentPage;
